<template>
	<div class="lifeMain">
		<mainLeft :info="info" />
		<mainRight />
	</div>
</template>

<script>
	import mainLeft from './mainLeft'
	import mainRight from './mainRight'

	export default {
		props:{
			info:{
				required:false,
				type:Object
			}
		},
		components: {
			mainLeft,
			mainRight
		}
	}
</script>

<style scoped>
	.lifeMain {
		width: 1300px;
		margin: auto;
		overflow: hidden;
	}
</style>
